export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref12217.bc6767ce.jpg";